/* eslint-disable react/prop-types */
import React from 'react';
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
} from 'components';
import ReactPlayer from 'react-player';
import { makeStyles } from '@mui/styles';
import styles from './styles';

const useStyles = makeStyles(styles);

export default function VideoPlayer(props) {
  const classes = useStyles();
  const { currentVideo } = props;

  return (
    <Portlet>
      <PortletHeader>
        <PortletLabel title={currentVideo ? currentVideo.title : 'Ayuda'} />
      </PortletHeader>
      <PortletContent>
        {currentVideo !== null ? (
          <ReactPlayer
            className={classes.video}
            controls
            height="100%"
            playing
            url={currentVideo.videoUrl}
            width="100%"
          />
        ) : (
          <div
            className={classes.video}
            style={{
              padding: '5rem 10rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              alt="Metimur Logo"
              height="100%"
              src="./images/logo-metimur-negro.jpg"
              width="100%"
            />
          </div>
        )}
      </PortletContent>
    </Portlet>
  );
}
